import { Loader } from "@components/atoms";
import { TaxedMoney } from "@components/containers";
import React from "react";
import { useIntl } from "react-intl";
import { commonMessages } from "../../../../intl";
import * as S from "./styles";

var CostLine = function CostLine(_ref) {
  var name = _ref.name,
      cost = _ref.cost,
      _ref$last = _ref.last,
      last = _ref$last === void 0 ? false : _ref$last,
      _ref$negative = _ref.negative,
      negative = _ref$negative === void 0 ? false : _ref$negative,
      _ref$loading = _ref.loading,
      loading = _ref$loading === void 0 ? false : _ref$loading;
  return React.createElement(S.CostLine, {
    last: last
  }, React.createElement("span", null, name), React.createElement("span", {
    "data-cy": "cartSummaryCost".concat(name.replace(/\s/g, ""))
  }, loading ? React.createElement(Loader, {
    inline: true,
    primary: last
  }) : React.createElement(React.Fragment, null, negative && "- ", React.createElement(TaxedMoney, {
    taxedMoney: cost
  }))));
};

var CartSummaryCosts = function CartSummaryCosts(_ref2) {
  var subtotal = _ref2.subtotal,
      promoCode = _ref2.promoCode,
      shipping = _ref2.shipping,
      total = _ref2.total,
      _ref2$promoCodeLoadin = _ref2.promoCodeLoading,
      promoCodeLoading = _ref2$promoCodeLoadin === void 0 ? false : _ref2$promoCodeLoadin;
  var intl = useIntl();
  return React.createElement(S.Costs, null, subtotal && React.createElement(CostLine, {
    name: intl.formatMessage(commonMessages.subtotal),
    cost: subtotal
  }), React.createElement(S.CostLine, {
    last: false
  }, React.createElement("span", null, intl.formatMessage(commonMessages.shipping)), React.createElement("span", null, intl.formatMessage(commonMessages.free))), promoCode && promoCode.gross.amount > 0 && React.createElement(CostLine, {
    name: intl.formatMessage(commonMessages.promoCode),
    cost: promoCode,
    negative: true,
    loading: promoCodeLoading
  }), total && React.createElement(CostLine, {
    name: intl.formatMessage(commonMessages.totalPrice),
    cost: total,
    last: true,
    loading: promoCodeLoading
  }));
};

export { CartSummaryCosts };